import { apiPost } from '@/shared/utils/requestBuilder';

import type { ResultadoDoSorteioDoSubstituto } from '../../types/sortearSubstituto';
import { handleError, unwrapData } from '../services';

export const sortearSubstitutoService = {
  /**
   * "Sortear árbitro substituto" (C2/C3): re-sorteio da vaga recusada no core. Erro sai como
   * `ErroHttp` com o `code` do core — 409 `VAGA_JA_PREENCHIDA` é a corrida perdida, 400
   * `SEM_SUBSTITUTO_ELEGIVEL` traz a frase que a tela mostra.
   */
  sortear: async (processoId: string): Promise<ResultadoDoSorteioDoSubstituto> => {
    const response = await apiPost(
      `/admin/arbitral/processos/${encodeURIComponent(processoId)}/sorteio/substituto`,
      {},
    );
    if (!response.ok) await handleError(response, 'Erro ao sortear o árbitro substituto');
    return unwrapData<ResultadoDoSorteioDoSubstituto>((await response.json()) as unknown);
  },
};
